import { unset } from 'lodash';
import type { Path } from 'react-hook-form';
import { CommonFormProps } from 'src/features/components/editComponentPage/forms/FormSelector.interface';
import type { IGcfComponentConfig } from 'src/interfaces';

import { deepObjectSetByPath } from './util-functions';

export const handleComponentConfigChange = (
  props: CommonFormProps,
  key: Path<IGcfComponentConfig>,
  value: unknown,
  fieldOnChange?: any,
) => {
  props.onChange(props.componentDetails.config ?? {}, key, value);
  fieldOnChange && fieldOnChange(value);
};

export const handleConfigUpdates = (
  data: any,
  path: string | string[],
  value: any | any[],
  keysToRemove: Array<string> = [],
) => {
  // deep set the changes to the formData
  const updatedFormData = Array.isArray(path)
    ? path.reduce((acc, curr, index) => {
        return deepObjectSetByPath(acc, curr, value[index]);
      }, data)
    : deepObjectSetByPath(data, path, value);

  // remove keys from data to be saved to the config
  keysToRemove.forEach((key) => {
    unset(updatedFormData, key);
  });

  return updatedFormData;
};
